import React from "react";
import { Dialog, DialogTitle, DialogContent, Typography, DialogActions, Box, CircularProgress } from "@mui/material";
// import { WarningAmber as WarningIcon } from "@mui/icons-material";

const LicenseInfoPopup = ({ open, setOpen, macAddress, loading }) => {
  const handleClose = () => setOpen(false); // Close the popup when called

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="license-info-popup-title"
      aria-describedby="license-info-popup-description"
      maxWidth="xs"
      fullWidth
    >
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: { xs: 2, sm: 3 },
        }}
      >
        {/* <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
          <WarningIcon sx={{ fontSize: 48, color: "#ff9800" }} />
        </Box> */}
        <DialogTitle
          id="license-info-popup-title"
          sx={{
            fontWeight: "bold",
            fontSize: { xs: "1.2rem", sm: "1.4rem" },
            textAlign: "center",
            padding: 0,
            mb: 1,
          }}
        >
          License Information
        </DialogTitle>

        <Typography
          variant="body1"
          sx={{
            mt: 1,
            fontSize: { xs: "0.9rem", sm: "1rem" },
            textAlign: "center",
          }}
        >
          Server MAC Address:{" "}
          {loading ? (
            <CircularProgress size={24} sx={{ color: "#ff9800" }} />
          ) : macAddress ? (
            <strong>{macAddress}</strong>
          ) : (
            <strong>Not available</strong>
          )}
        </Typography>

        <DialogActions sx={{ justifyContent: "center", mt: 3, width: "100%" }}>
          <button
            className="btn btn__secondary mt-10"
            type="button"
            onClick={handleClose}
            style={{ padding: "3px 6px", fontSize: "1rem" }}
          >
            Dismiss
          </button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default LicenseInfoPopup;
